export const CLIP_BOARD_COPY = "API/UI/CLIP_BOARD/COPY";
export const CLIP_BOARD_CLEAR = "API/UI/CLIP_BOARD/CLEAR";
export const CLIP_BOARD_COPY_STYLE = "API/UI/CLIP_BOARD/COPY_STYLE";
export const CLIP_BOARD_CLEAR_STYLE = "API/UI/CLIP_BOARD/CLEAR_STYLE";
